import React from "react";

import Datepicker from "../material/datepicker/Datepicker";
import Select from "../material/select/SelectV2";

export const TextFilter = ({ columnId, value, onChange }) => {
  const handleInputChange = (e) => {
    onChange(columnId, e.target.value);
  };

  return (
    <input
      type="text"
      value={value || ""}
      onChange={handleInputChange}
      className="border border-solid border-[#E1DFE3] py-1 px-2 w-full h-[38px] rounded-[5px]"
    />
  );
};

export const SelectFilter = ({ columnId, value, options, onChange, placeholder }) => {
  // const handleSelectChange = (e) => {
  //   onChange(columnId, e.target.value);
  // };

  return (
    <Select
      placeholder={placeholder}
      value={value}
      setValue={(value) => onChange(columnId, value)}
      list={options}
      style={{cursor:"pointer", width: "180px"}}
    />
  );
};

export const DateFilter = ({ columnId, value, onChange }) => {
  return (
    <div className="min-w-[160px] w-full">
      <Datepicker
        value={value || ""}
        setValue={(newValue) => onChange(columnId, newValue)}
        name={columnId}
      />
    </div>
  );
};
